import { Attendance } from '@pflegix/types';

export function canDefineFrequency(attendances: Attendance[]): boolean {
  return attendances.includes(Attendance.NV_91_ASSISTANCE);
}
